import { environment } from '@env';
import { configureStore } from '@reduxjs/toolkit';
import { appReducer } from '@reducers/appReducer';
import { authReducer } from '@reducers/authReducer';
import { userReducer } from '@reducers/userReducer';
import { answerReducer } from '@reducers/answerReducer';
import { questionnaireReducer } from '@reducers/questionnaireReducer';
import { submissionReducer } from '@reducers/submissionReducer';
import { submissionGroupReducer } from '@reducers/submissionGroupReducer';
import { lettersPageReducer } from '@reducers/lettersPageReducer';
import { answersPageReducer } from '@reducers/answersPageReducer';
import { feedbackReducer } from '@reducers/feedbackReducer';
import { roleReducer } from '@reducers/roleReducer';
import { unitReducer } from '@reducers/unitReducer';
import { submissionEnvironmentReducer } from '@reducers/submissionEnvironmentReducer';
import { answerEnvironmentReducer } from '@reducers/answerEnvironmentReducer';
import { questionnairesPageReducer } from '@reducers/questionnairesPageReducer';
import { rolesPageReducer } from '@reducers/rolesPageReducer';
import { appEnvironmentReducer } from '@reducers/appEnvironmentReducer';

export const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    user: userReducer,
    answer: answerReducer,
    questionnaire: questionnaireReducer,
    submission: submissionReducer,
    submissionGroup: submissionGroupReducer,
    lettersPage: lettersPageReducer,
    answersPage: answersPageReducer,
    feedback: feedbackReducer,
    role: roleReducer,
    unit: unitReducer,
    submissionEnvironment: submissionEnvironmentReducer,
    answerEnvironment: answerEnvironmentReducer,
    questionnairesPage: questionnairesPageReducer,
    rolesPage: rolesPageReducer,
    appEnvironmentReducer: appEnvironmentReducer,
  },
  devTools: !environment.isProduction,
});
